/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Turn_OnInputs */

const en_push_turn_on = /** @type {(inputs: Push_Turn_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on for this device`)
};

/**
* | output |
* | --- |
* | "Turn on for this device" |
*
* @param {Push_Turn_OnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_turn_on = /** @type {((inputs?: Push_Turn_OnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Turn_OnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_turn_on(inputs)
});